export default __webpack_public_path__ + "static/media/ny-photo.849aae46.jpg";